import { DateTime } from 'luxon';

// modified from https://stackoverflow.com/a/50376498
export function isNumber(value: string): boolean {
  if (value.includes(' ')) {
    return false;
  }
  return value != null && value !== '' && !isNaN(Number(value.toString()));
}

// all types on input as seen here:
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types
export const getInputTypes = (name: string): string => {
  switch (name) {
    case 'patient-zip':
    case 'policy-holder-zip':
    case 'policy-holder-zip-2':
    case 'weight':
      return 'number';
    case 'patient-number':
    case 'guardian-number':
    case 'pcp-number':
    case 'pcp-fax':
    case 'pharmacy-phone':
    case 'responsible-party-number':
    case 'person-accompanying-minor-phone-number':
    case 'invite-phone':
    case 'phoneNumber':
      return 'tel';
    default:
      return 'text';
  }
};

export function getAgeInYears(dateString: string): number {
  return Math.floor(DateTime.now().diff(DateTime.fromISO(dateString), 'years').years);
}

export function is18YearsOrYounger(dateString: string): boolean {
  const isValidDate = DateTime.fromISO(dateString).isValid;
  if (!isValidDate) {
    // this function is only used in erx, so conservatively use stricter requirements if dob invalid
    return true;
  }
  return getAgeInYears(dateString) <= 18;
}

export function isNullOrUndefined(value: any): boolean {
  return value === undefined || value === null;
}

export const isValidNumber = (value: number): boolean => {
  return typeof value === 'number' && !isNaN(value);
};

export const isPositiveNumberOrZero = (value: number): boolean => {
  return isValidNumber(value) && value >= 0;
};

// https://stackoverflow.com/a/13653180/2150542
const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/;
export const isValidUUID = (maybeUUID: string): boolean => {
  return uuidRegex.test(maybeUUID);
};

/**
 * Validates a resource ID that may be either a UUID (old-style FHIR Organization ID)
 * or a simple alphanumeric identifier (Oystehr RCM API payer ID).
 * Allows alphanumeric characters, underscores, and hyphens, but requires at least
 * one alphanumeric character and limits the total length to 64 characters.
 */
const resourceIdRegex = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]{1,64}$/;
export const isAlphaNumericID = (maybeId: string): boolean => {
  return resourceIdRegex.test(maybeId);
};
